<script setup lang="ts">
    import BaseButton from '@/components/BaseButton.vue';
    import { TOASTER_CONFIG } from '@/config.components';
    import { computed } from 'vue';
    import type { IToaster } from '@/typescript/interfaces/IToaster';

    defineEmits<{
        close: [];
    }>();

    const props = withDefaults(
        defineProps<{
            dataTest?: string;
            toaster: IToaster;
        }>(),
        {
            dataTest: 'toaster-base',
        },
    );

    const bgColor = computed(() => TOASTER_CONFIG[props.toaster.type]?.bgColor || TOASTER_CONFIG.info.bgColor);

    const textColor = computed(() => TOASTER_CONFIG[props.toaster.type]?.textColor || TOASTER_CONFIG.info.textColor);

    const borderColor = computed(() => TOASTER_CONFIG[props.toaster.type]?.borderColor || TOASTER_CONFIG.info.borderColor);

    const icon = computed(() => TOASTER_CONFIG[props.toaster.type]?.icon || TOASTER_CONFIG.info.icon);
</script>

<template>
    <div
        role="alert"
        :class="[
            bgColor,
            borderColor,
            'pointer-events-auto relative ml-2 flex w-full items-start gap-4 rounded-md border-2 px-5 py-4 align-top shadow-md md:max-w-2xl',
        ]"
        :data-test
    >
        <img
            :src="icon"
            :alt="`${$t('icon_toaster_alt')} - ${toaster.type}`"
        />
        <div class="flex flex-1 flex-col gap-4">
            <div :class="[textColor, 'font-bold']">
                {{ toaster.title }}
            </div>
            <div
                v-if="toaster.body"
                :class="textColor"
            >
                {{ toaster.body }}
            </div>
            <BaseButton
                v-if="toaster.action"
                data-test="toaster-action"
                class="mx-0 self-end"
                >{{ toaster.actionText }}</BaseButton
            >
            <div
                v-if="toaster.checkboxAction"
                class="flex gap-2"
            >
                <input
                    id="toaster-checkbox"
                    type="checkbox"
                    name="toaster-checkbox"
                    checked
                />
                <label for="toaster-checkbox">{{ toaster.checkboxText }}</label>
            </div>
        </div>
        <button
            data-test="toaster-close-button"
            @click="$emit('close')"
        >
            <span class="sr-only">{{ `${$t('close_alert_sr_only')} ${toaster.title}` }}</span>
            <img
                src="@/assets/images/picto/little-close.svg"
                :alt="$t('icon_close_alt')"
            />
        </button>
    </div>
</template>
